import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import MessengerCustomerChat from "react-messenger-customer-chat";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* <MessengerCustomerChat pageId="2047907412204648" /> */}
    {/* <HelmetProvider> */}
      <App />
    {/* </HelmetProvider> */}
  </React.StrictMode>
);

reportWebVitals();